<template>
	<article>
		<page-header :title="title" />
		<managing-section :column-count="2">
			<managing-box title="배너명">
				<input ref="bannerTitle" v-model="bannerTitle" type="text" />
			</managing-box>
			<managing-box title="노출 위치">
				<select ref="viewType" v-model="viewType" class="select">
					<option
						v-for="item in viewTypeList"
						:key="item.id"
						:value="item.id"
					>
						{{ item.name }}
					</option>
				</select>
			</managing-box>
			<managing-box title="이미지">
				<p class="banner__img-size">
					※ 이미지 사이즈 :
					{{
						Array.isArray(imgSize)
							? `${imgSize[0]} * ${imgSize[1]}`
							: imgSize
					}}
				</p>
				<img-selector
					v-if="Array.isArray(imgSize)"
					ref="bannerImgObj"
					:validation="bannerImgValidation"
					class="banner__img-selector"
					@change="bannerImgChange"
				/>
			</managing-box>
		</managing-section>
		<managing-section :splice="true">
			<managing-box title="링크" :horizontal-mode="true">
				<select ref="linkType" v-model="linkType" class="select">
					<option
						v-for="item in linkTypeList"
						:key="item.id"
						:value="item.id"
					>
						{{ item.name }}
					</option>
				</select>
				<input
					ref="linkValue"
					v-model="linkValue"
					class="banner__link-code"
					type="text"
					placeholder="이벤트번호 or 제품번호 입력"
				/>
			</managing-box>
		</managing-section>
		<div class="btn-wrap-main">
			<button class="btn-main" @click="cancel">취소</button>
			<button class="btn-main blue" @click="register">등록</button>
		</div>
		<managing-section :is-table="true">
			<table class="table-main banner__table">
				<colgroup>
					<col class="banner__table__img" />
					<col />
					<col class="banner__table__title" />
					<col />
					<col class="banner__table__manage" />
				</colgroup>
				<thead>
					<tr>
						<th class="banner__table__img">이미지</th>
						<th>배너명</th>
						<th colspan="2">내용</th>
						<th class="banner__table__manage">관리</th>
					</tr>
				</thead>
				<tbody v-for="item in list" :key="item.idBanner">
					<tr>
						<td class="banner__table__img" rowspan="2">
							<img-selector
								ref="bannerImgObjList"
								:show-file-name="true"
								:src="item.bannerImg"
								:vertical-ref-size="true"
								:thumbnail-height="180"
								@change="
									bannerImgObjListChange(
										$event,
										item.idBanner
									)
								"
							/>
						</td>
						<td rowspan="2">
							<input
								ref="bannerTitleList"
								:value="item.bannerTitle"
								type="text"
							/>
						</td>
						<th class="banner__table__title">노출위치</th>
						<td>
							<select
								ref="viewTypeList"
								:value="item.viewType"
								class="select banner__table__view-type"
							>
								<option
									v-for="item in viewTypeList"
									:key="item.id"
									:value="item.id"
								>
									{{ item.name }}
								</option>
							</select>
						</td>
						<td class="banner__table__manage" rowspan="2">
							<button
								class="btn blue banner__table__button"
								@click="savingBanner(item.idBanner)"
							>
								저장
							</button>
							<button
								class="btn red banner__table__button banner__table__button--delete"
								@click="deleteBanner(item.idBanner)"
							>
								삭제
							</button>
						</td>
					</tr>
					<tr>
						<th class="banner__table__title">링크</th>
						<td>
							<div class="banner__table__link-box">
								<select
									ref="linkTypeList"
									:value="item.linkType"
									class="select"
								>
									<option
										v-for="item in linkTypeList"
										:key="item.id"
										:value="item.id"
									>
										{{ item.name }}
									</option>
								</select>
								<input
									ref="linkValueList"
									:value="item.linkValue"
									class="banner__table__link-code"
									type="text"
								/>
							</div>
						</td>
					</tr>
				</tbody>
			</table>
		</managing-section>
	</article>
</template>
<script>
	import { mapState, mapGetters } from 'vuex';
	import { getS3Url, uploadS3 } from '@/util.js';
	import PageHeader from '@/components/PageHeader.vue';
	import ManagingSection from '@/components/layout/ManagingSection.vue';
	import ManagingBox from '@/components/layout/ManagingBox.vue';
	import ImgSelector from '@/components/ImgSelector.vue';

	export default {
		name: 'BannerManage',
		components: { PageHeader, ManagingSection, ManagingBox, ImgSelector },
		data() {
			return {
				idBrand: Number(this.$route.params.idBrand),
				title: '',
				bannerTitle: '',
				viewType: null,
				bannerImgObj: null,
				linkType: null,
				linkValue: '',
				list: [],
				imgChangesList: [],
			};
		},
		computed: {
			...mapState({
				IMAGE_STORAGE_PATH: state => state.env.IMAGE_STORAGE_PATH,
			}),
			...mapGetters(['getListAddNull']),
			viewTypeList() {
				return this.getListAddNull('viewType', null, '선택하세요.');
			},
			imgSize() {
				switch (this.viewType) {
					case null:
						return '노출 위치를 설정해주세요.';
					case 2101:
						return [311 * 3, 130 * 3];
					case 2102:
					case 2103:
						return [147 * 3, 56 * 3];
					case 2104:
						return [343 * 3, 144 * 3];
				}
			},
			linkTypeList() {
				return this.getListAddNull('newLinkType', null, '선택하세요.');
			},
		},
		watch: {
			viewType() {
				if (this.$refs.bannerImgObj) {
					this.$refs.bannerImgObj.init();
				}
			},
		},
		created() {
			this.setTitle();
		},
		mounted() {
			this.getList();
		},
		methods: {
			async setTitle() {
				const { data } = await this.$axiosAdmin2.get(
					`/api/brands?idBrand=${this.idBrand}`
				);
				this.title = `${this.$route.params.heading} - ${data.data[0].brandTitle}`;
			},
			bannerImgValidation(imgObj) {
				if (!Array.isArray(this.imgSize)) return false;
				if (this.imgSize[0] !== imgObj.naturalWidth) {
					alert(`이미지 가로사이즈 ${this.imgSize[0]}px!`);
					return false;
				}
				if (this.imgSize[1] !== imgObj.naturalHeight) {
					alert(`이미지 세로사이즈 ${this.imgSize[1]}px!`);
					return false;
				}
				return true;
			},
			bannerImgChange(bannerImgObj) {
				this.bannerImgObj = bannerImgObj;
			},
			cancel() {
				this.bannerTitle = '';
				this.viewType = null;
				this.$refs.bannerImgObj.init();
				this.linkType = null;
				this.linkValue = '';
			},
			async uploadImg(imgObj) {
				const { extension, fileObj } = imgObj;
				const { data } = await getS3Url(extension, 'banner');
				await uploadS3(data, fileObj);
				return `/${data.fields.key}`;
			},
			async getList() {
				const { data } = await this.$axiosAdmin2.get(
					`/v3/api/brand/recommend/${this.idBrand}/banner`
				);
				this.list = data;
			},
			async register() {
				if (!this.bannerTitle) {
					alert('배너명을 입력하세요.');
					this.$refs.bannerTitle.focus();
					return;
				}
				if (!this.viewType) {
					alert('노출위치를 선택하세요.');
					this.$refs.viewType.focus();
					return;
				}
				if (!this.bannerImgObj) {
					alert('사진을 추가하세요.');
					return;
				}
				if (!this.linkType) {
					alert('링크종류를 선택하세요.');
					this.$refs.linkType.focus();
					return;
				}
				if (!this.linkValue) {
					alert('링크내용을 입력하세요.');
					this.$refs.linkValue.focus();
					return;
				}
				if (!confirm('정말 등록하시겠습니까?')) return;
				const bannerImg = await this.uploadImg(this.bannerImgObj);
				const params = {
					bannerTitle: this.bannerTitle,
					viewType: this.viewType,
					bannerImg,
					linkType: this.linkType,
					linkValue: this.linkValue,
				};
				await this.$axiosAdmin2.post(
					`/v3/api/brand/recommend/${this.idBrand}/banner`,
					params
				);
				this.cancel();
				this.getList();
			},
			bannerImgObjListChange(nv, idBanner) {
				const idx = this.list.findIndex(
					item => item.idBanner === idBanner
				);
				this.imgChangesList[idx] = nv;
			},
			async savingBanner(idBanner) {
				const idx = this.list.findIndex(
					item => item.idBanner === idBanner
				);
				const bannerImgObjElem = this.$refs.bannerImgObjList[idx];
				const imgObj = this.imgChangesList[idx];
				const bannerTitleElem = this.$refs.bannerTitleList[idx];
				const bannerTitle = bannerTitleElem.value;
				const viewTypeElem = this.$refs.viewTypeList[idx];
				const viewType = Number(viewTypeElem.value);
				const linkTypeElem = this.$refs.linkTypeList[idx];
				const linkType = linkTypeElem.value;
				const linkValueElem = this.$refs.linkValueList[idx];
				const linkValue = linkValueElem.value;
				if (!bannerImgObjElem.imgObj) {
					alert('이미지를 선택하세요.');
					return;
				}
				if (!bannerTitle) {
					alert('배너명을 입력하세요.');
					bannerTitleElem.focus();
					return;
				}
				if (!viewType) {
					alert('노출위치를 선택하세요.');
					viewTypeElem.focus();
					return;
				}
				if (!linkType) {
					alert('링크타입을 선택하세요.');
					linkTypeElem.focus();
					return;
				}
				if (!linkValue) {
					alert('링크코드를 입력하세요.');
					linkValueElem.focus();
					return;
				}
				if (!confirm('정말 수정하시겠습니까?')) return;
				let bannerImg = this.list[idx].bannerImg.replace(
					this.IMAGE_STORAGE_PATH,
					''
				);
				if (imgObj) {
					bannerImg = await this.uploadImg(imgObj);
				}
				const params = {
					idBanner,
					bannerImg,
					bannerTitle,
					viewType,
					linkType,
					linkValue,
				};
				await this.$axiosAdmin2.post(
					`/v3/api/brand/recommend/${this.idBrand}/banner`,
					params
				);
				this.getList();
			},
			async deleteBanner(idBanner) {
				if (!confirm('정말 삭제하시겠습니까?')) return;
				await this.$axiosAdmin2.delete(
					`/v3/api/brand/recommend/${this.idBrand}/banner/${idBanner}`
				);
				this.getList();
			},
		},
	};
</script>
<style lang="scss" scoped>
	.banner__img-size {
		color: $font-blue;
	}

	.banner__img-selector {
		margin-top: 16px;
	}

	.banner__link-code {
		margin-left: 16px;
	}

	.banner__table {
		thead th {
			border-top: none;
		}

		tbody tr:hover {
			background: transparent;
		}

		tbody:last-of-type {
			th,
			td {
				border-bottom: 0;
			}
		}

		th {
			text-align: center;
		}
	}

	.banner__table__img {
		position: relative;
		width: 316px;
		text-align: left;
	}

	.banner__table__title {
		width: 82px;
		padding: 0;
		background: #f4f7fa;
	}

	.banner__table__link-box {
		display: flex;
	}

	.banner__table__link-code {
		margin-left: 16px;
	}

	.banner__table__manage {
		width: 100px;
		padding: 0;
	}

	.banner__table__button {
		display: block;
		margin: 0 auto;
	}

	.banner__table__button--delete {
		margin-top: 12px;
	}

	.banner__table__view-type {
		width: 100%;
	}
</style>
